module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bookmarkNavOpened) ? _c('md-layout', {
    staticClass: "bookmarkNav",
    class: {
      'bookmarkNav--resizing': _vm.resizing
    },
    style: (_vm.navStyle),
    attrs: {
      "md-column": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "bookmarkTopBar"
  }, [_c('h3', [_vm._v("Navigation")]), _vm._v(" "), _c('md-button', {
    staticClass: "closeBookmark md-fab md-clean md-mini",
    on: {
      "click": _vm.toggleBookmarkNav
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('md-tabs', {
    ref: "navTabs",
    staticClass: "bookmark-nav-tabs",
    attrs: {
      "md-fixed": ""
    },
    on: {
      "change": _vm.onTabChange
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "structure",
      "md-label": "Structure",
      "md-active": _vm.currentTab === 'structure'
    }
  }, [(!_vm.navMarkers.length) ? _c('p', {
    staticClass: "bookmark-empty-hint"
  }, [_vm._v("No act, scene, or song structure marks yet.")]) : _c('md-list', {
    staticClass: "bookmarks-list marker-nav-list"
  }, _vm._l((_vm.navMarkers), function(marker) {
    return _c('marker-nav-item', {
      key: marker.markerId || marker.id,
      attrs: {
        "marker": marker,
        "currentPage": _vm.currentPage
      },
      on: {
        "gotoPage": _vm.gotoPage
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "structure-visibility"
  }, [_c('md-switch', {
    staticClass: "md-primary structure-visibility__switch",
    attrs: {
      "disabled": !_vm.navMarkers.length
    },
    model: {
      value: (_vm.hideMarksLocal),
      callback: function($$v) {
        _vm.hideMarksLocal = $$v
      },
      expression: "hideMarksLocal"
    }
  }, [_vm._v("\n                    Hide structure marks on script\n                ")])], 1), _vm._v(" "), (_vm.canManageMarkers) ? _c('button', {
    staticClass: "ql-btn ql-btn--primary ql-btn--block bookmark-panel-btn bookmark-manage-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openManageMarkers
    }
  }, [_vm._v("\n                Manage structure\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "bookmarks",
      "md-label": "My Bookmarks",
      "md-active": _vm.currentTab === 'bookmarks'
    }
  }, [(!_vm.hasPrivateBookmarks) ? _c('p', {
    staticClass: "bookmark-empty-hint"
  }, [_vm._v("No private bookmarks yet.")]) : _vm._e(), _vm._v(" "), (_vm.versionID && _vm.hasPrivateBookmarks) ? _c('md-list', {
    staticClass: "bookmarks-list"
  }, _vm._l((_vm.versionBookmarks), function(title, page) {
    return _c('bookmark-item', {
      key: page,
      attrs: {
        "currentPage": _vm.currentPage,
        "page": page,
        "title": title,
        "startEdit": _vm.isFocusedBookmark(page)
      },
      on: {
        "gotoPage": _vm.gotoPage,
        "editStarted": _vm.clearBookmarkFocus
      }
    })
  }), 1) : (_vm.hasPrivateBookmarks) ? _c('md-list', {
    staticClass: "bookmarks-list"
  }, _vm._l((_vm.bookmarks), function(title, page) {
    return _c('bookmark-item', {
      key: page,
      attrs: {
        "currentPage": _vm.currentPage,
        "page": page,
        "title": title,
        "startEdit": _vm.isFocusedBookmark(page)
      },
      on: {
        "gotoPage": _vm.gotoPage,
        "editStarted": _vm.clearBookmarkFocus
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ql-btn ql-btn--primary ql-btn--block bookmark-panel-btn bookmark-import-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.collaboratorList.length === 0,
      "title": _vm.collaboratorList.length === 0 ?
        'Bookmark import is only available from project collaborators' :
        null
    },
    on: {
      "click": _vm.openImportBookmarkModal
    }
  }, [_vm._v("\n                Import Bookmarks\n            ")])], 1)], 1), _vm._v(" "), _c('manage-script-markers-dialog', {
    ref: "manageMarkersDialog",
    attrs: {
      "currentPage": _vm.currentPage,
      "pageWidth": 0,
      "pageHeight": 0,
      "totalPages": _vm.totalPages
    }
  }), _vm._v(" "), _c('md-dialog', {
    ref: "import-bookmark-from"
  }, [_c('md-dialog-title', [_vm._v("Import Bookmarks")]), _vm._v(" "), _c('md-dialog-content', [(_vm.collaboratorList.length === 0) ? _c('div', [_c('span', [_vm._v("Bookmark import is only available from project collaborators. You currently do not have any collaborators on this project.")])]) : _vm._l((_vm.collaboratorList), function(collaborator) {
    return _c('div', {
      key: collaborator.uid
    }, [(collaborator.uid && collaborator.name) ? _c('md-radio', {
      attrs: {
        "md-value": collaborator.uid
      },
      model: {
        value: (_vm.candidate),
        callback: function($$v) {
          _vm.candidate = $$v
        },
        expression: "candidate"
      }
    }, [_vm._v("\n                        " + _vm._s(collaborator.name) + "\n                    ")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.cancelBookmarkImport
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": !_vm.candidate
    },
    on: {
      "click": _vm.importBookmarkFrom
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bookmarkNav-resizer",
    attrs: {
      "title": "Drag to resize"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.startResize.apply(null, arguments)
      },
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.startResize.apply(null, arguments)
      },
      "dblclick": _vm.resetWidth
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "confirm-bookmark-merge",
    attrs: {
      "md-title": _vm.mergeBookmarkConfirm.title,
      "md-content-html": _vm.mergeBookmarkConfirm.description,
      "md-ok-text": _vm.mergeBookmarkConfirm.ok,
      "md-cancel-text": _vm.mergeBookmarkConfirm.cancel
    },
    on: {
      "close": _vm.confirmMergeBookmark
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c334dd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/bookmark/nav.vue
// module id = 1247
// module chunks = 21